var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.channel
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "spinner-border text-secondary",
              attrs: { role: "status" },
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t("global.loading"))),
              ]),
            ]
          ),
        ])
      : _c(
          "div",
          [
            _c("ChannelForm", {
              staticClass: "mb-4",
              model: {
                value: _vm.channel,
                callback: function ($$v) {
                  _vm.channel = $$v
                },
                expression: "channel",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex pt-3",
                staticStyle: {
                  gap: "1rem",
                  "justify-content": "flex-end",
                  "margin-bottom": "-1rem",
                },
              },
              [
                _c(
                  "Button2",
                  {
                    attrs: { disabled: !_vm.channel.value || _vm.isSubmitted },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.saveChannel(_vm.watchmanId, _vm.channel)
                      },
                    },
                  },
                  [
                    _vm.isSubmitted
                      ? _c("span", {
                          staticClass: "spinner-border spinner-border-sm ml-2",
                          attrs: {
                            role: "status",
                            "aria-label": _vm.$t("global.loading"),
                          },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("global.save")) + "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
    _vm._v(" "),
    _vm.error
      ? _c("div", [
          _c("div", { staticClass: "alert alert-danger" }, [
            _c("pre", [_vm._v(_vm._s(JSON.stringify(_vm.error, null, 2)))]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }